<script lang="ts">
	import Section from '$lib/components/Section.svelte';
	import type { Snippet } from 'svelte';

	let {
		metadata,
		children
	}: {
		metadata: BlogPostMetadata;
		children?: Snippet;
	} = $props();

	let minutesToRead = `${metadata.readingTime} ${metadata.readingTime > 1 ? 'minutes' : 'minute'}`;
</script>

<Section
	class="prose md:prose-lg dark:prose-invert prose-hr:mt-6 prose-hr:mb-0  prose-base dark:prose-base md:dark:prose-lg prose-headings:mb-4 prose-headings:md:mb-8 prose-headings:md:mt-8 prose-headings:mt-4 prose-p:mb-3 prose-p:mt-2 !mx-auto w-full max-w-5xl"
>
	<a
		href="/blog"
		class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
	>
		&larr; Back to blog
	</a>
	<h1 class="font-bold">{metadata.title}</h1>
	<p class="text-xl text-gray-500 dark:text-gray-400">{metadata.description}</p>
	<p class="text-gray-500 dark:text-gray-400">
		{new Date(metadata.date).toLocaleDateString()} &mdash; <em>{minutesToRead} read</em>
	</p>
	<hr />
</Section>
<Section
	class="prose md:prose-lg dark:prose-invert prose-base dark:prose-base dark:md:prose-lg prose-p:mb-2 prose-p:mt-1 prose-h1:mb-4 prose-h1:mt-6 prose-headings:mt-3 prose-headings:mb-2 sm:prose-headings:mt-6 sm:prose-headings:mb-2 prose-img:rounded-lg prose-img:shadow-lg; container !mx-auto w-full max-w-5xl space-y-[unset]"
>
	{#if children}
		{@render children?.()}
	{:else}
		<p class="text-gray-500 dark:text-gray-400">
			Uh-oh! There's supposed to be content here, but I messed up the code!
		</p>
	{/if}
</Section>
